import * as React           from 'react';
import UsersGrid from "../../components/bo-core/grids/UsersGrid/UsersGrid";

class Users extends React.Component {
    render() {
        return (
            <div style={{backgroundColor: '#2D3436', height: '100%'}}>
                <UsersGrid/>
            </div>
        );
    }
}
export default Users



// WEBPACK FOOTER //
// ./app/views/bo-core/Users.tsx